module.exports = __webpack_public_path__ + "static/img/chrome.8a08e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chrome.png
// module id = AluB
// module chunks = 0